import { createApiSlice } from "@common";
import {
    MY_INFO_CERTIFICATION_DETAILS
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addEmployeeCertifications",
        method: "post",
        url: MY_INFO_CERTIFICATION_DETAILS,
        stateKey: "message",
    },
    {
        name: "getEmployeeCertifications",
        method: "get",
        url: MY_INFO_CERTIFICATION_DETAILS,
        stateKey: "data",
    },
    {
        name: "updateEmployeeCertifications",
        method: "put",
        url: MY_INFO_CERTIFICATION_DETAILS,
        stateKey: "message",
    },
    {
        name: "deleteEmployeeCertifications",
        method: "delete",
        url: MY_INFO_CERTIFICATION_DETAILS,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "EmployeeCertifications",
    apiConfig,
    customReducers,
);
const EmployeeCertificationsSlice = slice;
// Export the slice's reducer
export default EmployeeCertificationsSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addEmployeeCertifications,
    getEmployeeCertifications,
    updateEmployeeCertifications,
    deleteEmployeeCertifications
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
